<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="8">
					<!-- 품번 -->
					<search-input
						:label="getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:propData="pprNoPopupSearch.partNo"
					>
					</search-input>
				</el-col>
				<el-col :span="8">
					<!-- 품명 -->
					<search-input
						:label="getMessage_('QWCC000957')"
						paramKey="partNm"
						@commInput="setSearchParam"
						:propData="pprNoPopupSearch.partNm"
					>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="4">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="pprNoPopupSearch.cofNm"
						:readonly="!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp)"
						:iconReadonly="!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp)"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onCofPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		propPartNo: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false }, // 시스템 관리자
		flgPqyapGrp: { type: Boolean, default: false }, //승인자
		flgPqyrvGrp: { type: Boolean, default: false }, //검토자
		flgPqyrgGrp: { type: Boolean, default: false }, //작성자
		flgPqycpGrp: { type: Boolean, default: false } //외부협력사
	},
	components: {
		SearchInput,
		CompPopup
	},
	// data() {
	// 	return {
	// 		searchParams: {
	// 			partNo: '',
	// 			partName: ''
	// 		}
	// 	};
	// },
	async created() {
		this.pprNoPopupSearch.partNo = this.propPartNo;
		const cpnyUser = !!(this.flgOsGrp || this.flgPqyapGrp || this.flgPqyrvGrp || this.flgPqyrgGrp);
		if (!cpnyUser && this.flgPqycpGrp) {
			const { cpnyCd, cpnyNm, partnerYn } = await this.getPartnerInfo_();
			if (!partnerYn || partnerYn === 'N')
				throw new Error(this.getMessage_('QWCC001885')); //사용자의 업체 정보를 불러올 수 없습니다. 관리자에게 문의하세요.
			else {
				// console.log('cpnyUser cpnyCd, cpnyNm, partnerYn>>> ', cpnyCd, cpnyNm, partnerYn);
				await this.setSearchParam({ key: 'cofCd', value: cpnyCd });
				await this.setSearchParam({ key: 'cofNm', value: cpnyNm });
			}
		}

		// await this.searchList();
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...qmsMethods,
		...serviceMethods,
		async searchList() {
			// console.log('PqPartPopupSearch 에서 searchList 실행>>>', this.pprNoPopupSearch);
			this.$sf_toggleLoading(true);
			await this.getPprNoPopupList_(this.pprNoPopupSearch)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		setSearchParam({ key, value }) {
			this.pprNoPopupSearch[key] = value;
		},
		reset(param) {
			this.pprNoPopupSearch.partNo = param ? param : '';
			this.pprNoPopupSearch.partName = '';
			this.pprNoPopupSearch.cofCd = '';
			this.pprNoPopupSearch.cofNm = '';
			this.pprNoPopupSearch.pprNo = '';
		},
		//협력사 팝업조회
		onCofPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.pprNoPopupSearch.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setSearchParam({ key: 'cofCd', value: cpnyCd });
			this.setSearchParam({ key: 'cofNm', value: cpnyNm });
		}
	}
};
</script>

<style></style>
